<mat-icon *ngIf="isLoading">
	<mat-spinner diameter="20"></mat-spinner>
</mat-icon>

<app-msg *ngIf="!isLoading && msg && msg.MSG" [msg]="msg"></app-msg>